import { ProjectDuration } from '../gql-operations/gql-generated';

export const DURATION_TO_KEY_MAP = {
    [ProjectDuration.OneToSevenDays]: 'one_to_seven_days',
    [ProjectDuration.SevenToThirtyDays]: 'seven_to_thirty_days',
    [ProjectDuration.OneToThreeMonths]: 'one_to_three_months',
    [ProjectDuration.ThreeToSixMonths]: 'three_to_six_months',
    [ProjectDuration.SixPlusMonths]: 'six_plus_months',
} as const;
